import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TaskNotification } from '../../hrms/api/tasks';

interface State {
  items: TaskNotification[];
  hydrated: boolean;
}

const initialState: State = { items: [], hydrated: false };

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    bulkHydrate(state, action: PayloadAction<TaskNotification[]>) {
      state.items = action.payload;
      state.hydrated = true;
    },
    pushNotification(state, action: PayloadAction<TaskNotification>) {
      // Dedupe by id (backend may resend on reconnect)
      if (state.items.some(i => i.id === action.payload.id)) return;
      state.items.unshift(action.payload);
      // Cap at 100 in memory; bell shows 50 anyway
      if (state.items.length > 100) state.items.length = 100;
    },
    markRead(state, action: PayloadAction<string>) {
      const it = state.items.find(i => i.id === action.payload);
      if (it) it.is_read = true;
    },
    markAllRead(state) {
      state.items.forEach(i => { i.is_read = true; });
    },
    removeNotification(state, action: PayloadAction<string>) {
      state.items = state.items.filter(i => i.id !== action.payload);
    },
    removeAllNotifications(state) {
      state.items = [];
    },
    clearNotifications(state) {
      state.items = [];
      state.hydrated = false;
    },
  },
});

export const {
  bulkHydrate, pushNotification, markRead, markAllRead,
  removeNotification, removeAllNotifications, clearNotifications,
} = slice.actions;

export const selectNotifications = (s: any) => s.notifications.items as TaskNotification[];
export const selectUnreadCount = (s: any) =>
  (s.notifications.items as TaskNotification[]).filter(i => !i.is_read).length;
export const selectNotificationsHydrated = (s: any) => s.notifications.hydrated as boolean;

export default slice.reducer;
